import { MDBPopover } from "mdb-react-ui-kit";
import { PopoverProps } from "mdb-react-ui-kit/dist/types/free/components/Popover/types";
import { placement } from "mdb-react-ui-kit/dist/types/types/placement";
import { CSSProperties, useCallback, useEffect, useRef, useState } from "react";

export interface CustomPopoverProps {
    color?: "link" | "none" | "dark" | "light" | "success" | "warning" | "info" | "primary" | "secondary" | "danger" | "muted" | "white" | "tertiary";
    btnClassName?: string;
    dismiss?: boolean;
    trigger: React.ReactNode;
    children: React.ReactNode | ((close: () => Promise<void>) => React.ReactNode);
    placement: placement;
    style?: CSSProperties;
    popoverZIndex?: number;
    onOpen?: () => void;
    onClose?: () => void;
    onCloseFinished?: () => void;
}
export const CustomPopover = ({color, btnClassName, trigger, placement, style, popoverZIndex, children, onOpen, onClose, onCloseFinished}: CustomPopoverProps) => {
    const [open, setOpen] = useState(false);

    const onBackgroundClick = useCallback(() => {
        setOpen(false);
    }, []);

    const close = useCallback(async () => {
        setOpen(false);
        await new Promise(resolve => setTimeout(resolve, 200));
    }, []);

    const onPopoverOpen = useCallback(() => {
        setOpen(true);
        if (onOpen) onOpen();
    }, []);

    const onPopoverClose = useCallback(() => {
        setOpen(false);
        if (onClose) onClose();
        setTimeout(() => {
            if (onCloseFinished) onCloseFinished();
        }, 200);
    }, []);

    return (
        <>
            <MDBPopover
                open={open}
                color={color || "link"}
                btnClassName={`p-0 text-dark btn-no-effects ${btnClassName ?? ""}`}
                btnChildren={trigger}
                placement={placement}
                onOpen={onPopoverOpen}
                onClose={onPopoverClose}
                poperStyle={{zIndex: popoverZIndex ?? 1051, ...style}}
                style={{textTransform: 'none'}}
            >
                <div>
                    {typeof children == 'function' ? children(close) : children}
                </div>
                
            </MDBPopover>
            { open &&
                <div className="w-100 h-100 position-fixed" style={{left: 0, top: 0, zIndex: (popoverZIndex ?? 1051)-1}} onClick={onBackgroundClick}></div>
            }
        </>
        
    )
}